<template>
  <label class="radio-container" :class="radioColor">
    <span aria-hidden="true" v-if="radioShowText">{{ radioText }}</span>
    <input
      type="radio"
      :value="radioValue"
      :name="radioName"
      :checked="radioChecked"
      :disabled="radioDisabled"
      :aria-label="radioText"
      @change="$emit('input', radioValue)"
    />
    <div class="radio" :class="{ disabled: radioDisabled }"></div>
  </label>
</template>

<script>
export default {
  name: 'CertRadioButton',
  props: {
    radioName: String,
    radioChecked: {
      type: Boolean,
      default: false,
    },
    radioShowText: {
      type: Boolean,
      default: false,
    },
    radioText: {
      type: String,
      default: '',
    },
    radioValue: {
      type: String,
      default: '',
    },
    radioColor: {
      type: String,
      default: '',
    },
    radioDisabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
$radioSize: 27px;
$dotSize: 7px;
$dotPos: 6px;

.radio-container {
  display: block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  @include fontSize(14px);
  height: $radioSize;
  line-height: $radioSize;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .radio {
    position: absolute;
    top: 0;
    left: 0;
    height: $radioSize;
    width: $radioSize;
    border-radius: 50%;
    border: 4px solid #fff;
  }

  .radio:not(.disabled):hover,
  .radio:not(.disabled):focus {
    border: 4px solid #bed4ee;
    //$exBlue * 0.25 opacity
  }
}

.radio-container input ~ .radio {
  background-color: $exBlue;
}
.radio-container.red input ~ .radio {
  background-color: $t1Red;
}
.radio-container.blue input ~ .radio {
  background-color: $t1Blue;
}
.radio-container.green input ~ .radio {
  background-color: $t1Green;
}
.radio-container.brown input ~ .radio {
  background-color: $t1Brown;
}

.radio-container.red input:checked ~ .radio {
  background-color: $t1Red;
}
.radio-container.blue input:checked ~ .radio {
  background-color: $t1Blue;
}
.radio-container.green input:checked ~ .radio {
  background-color: $t1Green;
}
.radio-container.brown input:checked ~ .radio {
  background-color: $t1Brown;
}

.radio:after {
  content: '';
  position: absolute;
  display: none;
}

.radio-container input:checked ~ .radio:after {
  display: block;
}

.radio-container .radio:after {
  top: $dotPos;
  left: $dotPos;
  width: $dotSize;
  height: $dotSize;
  border-radius: 50%;
  background: #fff;
}
</style>
